export const removeAllMask = (list) =>
  list.map((item) => item.replace(/[^\d]+/g, ''));

export const removeMask = (item) => item.replace(/[^\d]+/g, '');

export const removeMaskCnpj = (item) => item.replace(/[^a-zA-Z0-9]+/g, '');

export const removeSymbol = (item) => item.replace(/[^\w]+/g, '');

export const removeUnderscore = (item) => item.replace(/_/g, '');

export const remSymbolAllowAccent = (item) =>
  item.replace(/[^a-zA-Zà-úÀ-Ú0-9\s]+/g, '');
